// extracted by mini-css-extract-plugin
export default {"cls1":"TracesReview-Sidebar-module--cls1--NRvKs","cls2":"TracesReview-Sidebar-module--cls2--jhQMj TracesReview-Sidebar-module--cls1--NRvKs"};